import React, { useState } from 'react';
import axios from 'axios';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { buyTicketStyles, checkoutStyles } from '../styles';
import { useSelector } from 'react-redux';
import { Checkbox } from '@mui/material';
import Radio from '@mui/material/Radio';
import { MinLoader } from 'components';

const cardElementOptions = {
    style: {
        base: {
            color: '#666',
            fontSize: '16px',
        },
        invalid: {
            color: '#fa755a',
            fontSize: '16px',
        },
    },
};

export const StripeCard = ({ handlePay, currentCard, backLoader }) => {
    const [cardError, setCardError] = useState('');
    const [loader, setLoader] = useState(false);
    const [checked, setChecked] = useState(false);
    const [checkoutError, setCheckoutError] = useState();
    const [email, setEmail] = useState();
    const stripe = useStripe();
    const elements = useElements();
    const cardClasses = checkoutStyles();
    const classes = buyTicketStyles();
    const { accessToken } = useSelector((state) => ({
        accessToken: state.auth.accessToken,
    }));
    const token = accessToken ? accessToken : typeof window !== 'undefined' && localStorage.getItem('access-token');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        setCardError('');
        try {
            const {error, paymentMethod } = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement('card'),
            });

            if (error) {
                switch (error.code) {
                    case 'incomplete_number':
                    case 'invalid_number':
                        setCardError('Please enter a valid card number.');
                        break;
                    case 'incomplete_expiry':
                    case 'invalid_expiry_year_past':
                    case 'invalid_expiry_year':
                    case 'invalid_expiry_month':
                        setCardError('Please enter a valid expiry date.');
                        break;
                    case 'incomplete_cvc':
                    case 'invalid_cvc':
                        setCardError('Please enter a valid CVV.');
                        break;
                    default:
                        setCardError(error.message);
                }
                setLoader(false);
            }else {
                if (token) {
                    await axios
                        .post('/billing/pmtMethod', { pmtMethod: paymentMethod?.id }, { auth: true })
                        .then(() => {
                            handlePay(email, paymentMethod?.id);
                            setLoader(false);
                        })
                        .catch((e) => {
                            setCardError(e?.data?.message);
                            setLoader(false);
                        });
                } else {
                    handlePay(email, paymentMethod?.id);
                    setLoader(false);
                }
            }


        } catch (err) {
            setCheckoutError(err.message);
            setLoader(false);
        }
    };

    const handleCardChange = () => {
        if (cardError) setCardError('');
    };


    return (
        <div style={{ width: '100%' }}>
            <form onSubmit={handleSubmit} className={classes.addCardForm}>
                <div style={{ background: '#F7F8FA' }} className={classes.newCardWrapper}>
                    <div className={classes.newCardWrapperHead} style={{ marginTop: '4px' }}>
                        <div className={classes.cardInformationWrapper} style={{ marginLeft: '0' }}>
                            <p className={classes.cardTypeText}>+ Add New Card</p>
                        </div>
                        {currentCard?.card ? <Radio style={{ color: '#BB3240' }} checked={true} /> : null}
                    </div>

                    {!token && (
                        <>
                            <p style={{ marginTop: '24px' }} className={cardClasses.cardTitle}>
                                {'Email*'}
                            </p>
                            <div className={cardClasses.cardEmailInput}>
                                <input type="email" required={true} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                        </>
                    )}

                    <p style={{ marginTop: '12px' }} className={cardClasses.cardTitle}>
                        {'Card Number'}
                    </p>
                    <div className={cardClasses.cardInputWrapper}>
                        <CardElement options={cardElementOptions} onChange={handleCardChange} />
                    </div>
                    {checkoutError && <span style={{ color: 'red', fontSize: '12px' }}>{checkoutError}</span>}

                    {cardError && (
                        <p style={{ color: '#fa755a', marginTop: '10px' }}>
                            {cardError === "Can not create customer Error: Your card's security code is incorrect."
                                ? "Your card's security code is incorrect."
                                : cardError === 'Can not create customer Error: Your card has expired.'
                                ? 'Your card has expired.'
                                : cardError ===
                                  'Can not create customer Error: An error occurred while processing your card. Try again in a little bit.'
                                ? 'An error occurred while processing your card. Try again in a little bit.'
                                : cardError === 'Can not create customer Error: Your card was declined.'
                                ? 'Your card was declined.'
                                : cardError ===
                                  'This customer has no attached payment source or default payment method. Please consider adding a default payment method. For more information, visit https://stripe.com/docs/billing/subscriptions/payment-methods-setting#payment-method-priority.'
                                ? 'Input is not field'
                                : cardError}
                        </p>
                    )}
                    <div className={cardClasses.checkboxWrapper}>
                        <Checkbox  style={{ color: '#BB3240' }} checked={checked} name="available" onClick={() => setChecked(!checked)} />
                        <p className={cardClasses.acceptText}>
                            I agree with the
                            <a href="/termAndCondition" className={cardClasses.linkText}>
                                terms and conditions
                            </a>
                        </p>
                    </div>
                </div>

                <div className={classes.continueBtnWrapper}>
                    <button
                        className={classes.completeBtn}
                        type="submit"
                        style={checked === false ? { background: '#E0A1A7' } : {}}
                        disabled={checked === false}>
                        {loader || backLoader?.length ? <MinLoader color={'white'} margin='0px' /> : 'Complete Payment'}
                    </button>
                </div>
            </form>
        </div>
    );
};
